import callApi from './partials/api';
import callApiErrorCodeFormat from './partials/apiErrorCodeFormat';
import authorization from './partials/authorization';

export default {
  // 判斷可否使用折價券
  queryClassInit({ InitID }, cb) {
    callApi('post', `Class/QueryClassInit`, cb, {
      data: {
        InitID,
      },
    });
  },

  // 會員紅利查詢
  mmBonusTotal({ companyId, branchId }, cb) {
      callApiErrorCodeFormat('get', `MmBonusAPI/mmBonusTotal/${companyId}/${branchId}`, cb, {
      ...authorization(),
    });
  },

  //紅利點數資格查詢
  queryRedeemHola({ CompanyID, BranchId, bonusPoints }, cb, errCb) {
    callApi(
      'post',
      `Order/QueryRedeemHola`,
      cb,
      {
        data: {
          CompanyID,
          BranchId,
          bonusPoints,
        },
        ...authorization(),
      },
      errCb
    );
  },

  //即享券查詢
  checkAccount({ accountNo, s_no }, cb, errCb) {
    callApiErrorCodeFormat(
      'post',
      `TLWPayAPI/checkAccount`,
      cb,
      {
        data: {
          accountNo,
          s_no,
        },
        ...authorization(),
      },
      errCb
    );
  },

  //折價資格券查詢
  queryCrmcoup(
    {
      CompanyID,
      BranchId,
      DiscSku,
      ClassAmnt,
      OrderCnt,
      DiscupType,
      skipSetApiStatus,
    },
    cb,
    errCb
  ) {
    callApi(
      'post',
      `Order/QueryCrmcoup091013`,
      cb,
      {
        data: {
          CompanyID,
          BranchId,
          DiscSku,
          ClassAmnt,
          OrderCnt,
          DiscupType,
        },
        ...authorization(),
        skipSetApiStatus,
      },
      errCb
    );
  },

  //可用折價券查詢
  couponList({ companyId, channelId, storeId, grnoList }, cb) {
    callApiErrorCodeFormat('post', `/CouponAPI/couponList`, cb, {
      data: {
        companyId,
        channelId,
        storeId,
        grnoList,
      },
      ...authorization(),
    });
  },
};
